import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c7bf67e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-bottom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-bottom-left" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "© Copyright 2021, USAE LLC. All rights reserved.")
], -1))
const _hoisted_4 = { class: "footer-bottom-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("404-860-1284")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("support@ammoexchange.com")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/legal" }, {
          default: _withCtx(() => [
            _createTextVNode("User Agreement")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}